import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import Loader from 'components/Loader';
import MobileAppPayBillDrawer from 'containers/PrimoAccount/NextDelivery/MakePayment/PayBillDrawer';
import { selectIsBillingInformationFetching } from 'containers/PrimoProfile/selectors';
import {
  selectFetchPayBillDataError,
  selectLoadServiceLocationIsFetching,
} from 'containers/PrimoAccount/selectors';
import { PROFILE_PAGE_KEY } from 'containers/PrimoProfile/constants';
import primoProfileReducer from 'containers/PrimoProfile/reducer';
import primoProfileSaga from 'containers/PrimoProfile/saga';
import { getMobileAppBillPayData } from 'containers/PrimoAccount/actions';
import { PRIMO_ACCCOUNT_PAGE_KEY } from 'containers/PrimoAccount/constants';
import primoAccountSaga from 'containers/PrimoAccount/saga';
import primoAccountReducer from 'containers/PrimoAccount/reducer';

import injectSaga from 'utils/injectSaga';
import injectReducer from 'utils/injectReducer';

const PayMyBill = ({
  fetchMobileAppBillPayData,
  isLoadServiceLocationIsFetching,
  IsBillingInformationFetching,
  fetchPayBillDataError,
}) => {
  const [isFetchInitiated, setIsFetchInitiated] = useState(false);

  useEffect(() => {
    fetchMobileAppBillPayData();
    setIsFetchInitiated(true);
  }, []);

  return (
    <Loader
      loading={
        !isFetchInitiated ||
        isLoadServiceLocationIsFetching ||
        IsBillingInformationFetching
      }
    >
      <div>
        {fetchPayBillDataError ? (
          <h1>fetchPayBillDataError</h1>
        ) : (
          <MobileAppPayBillDrawer open onClose={() => {}} isMobileAppView />
        )}
      </div>
    </Loader>
  );
};

const mapDispatchToProps = {
  fetchMobileAppBillPayData: getMobileAppBillPayData,
};

const mapStateToProps = createStructuredSelector({
  isLoadServiceLocationIsFetching: selectLoadServiceLocationIsFetching(),
  IsBillingInformationFetching: selectIsBillingInformationFetching(),
  fetchPayBillDataError: selectFetchPayBillDataError(),
});

PayMyBill.propTypes = {
  isLoadServiceLocationIsFetching: PropTypes.bool.isRequired,
  IsBillingInformationFetching: PropTypes.bool.isRequired,
  fetchMobileAppBillPayData: PropTypes.func.isRequired,
  fetchPayBillDataError: PropTypes.string,
};

const withReducer = injectReducer({
  key: PROFILE_PAGE_KEY,
  reducer: primoProfileReducer,
});
const withSaga = injectSaga({
  key: PROFILE_PAGE_KEY,
  saga: primoProfileSaga,
});
const withPrimoAccountReducer = injectReducer({
  key: PRIMO_ACCCOUNT_PAGE_KEY,
  reducer: primoAccountReducer,
});
const withPrimoAccountSaga = injectSaga({
  key: PRIMO_ACCCOUNT_PAGE_KEY,
  saga: primoAccountSaga,
});

export default compose(
  withReducer,
  withPrimoAccountReducer,
  withSaga,
  withPrimoAccountSaga,
  connect(mapStateToProps, mapDispatchToProps),
)(PayMyBill);
